import { MessageSquare } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MessageSquareIcon = createLucideIcon(MessageSquare);
